import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-up",
  "use": "icon-chevron-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chevron-up\"><defs><style type=\"text/css\"></style></defs><path d=\"M316.16 657.493333L512 462.08l195.84 195.413333L768 597.333333l-256-256-256 256 60.16 60.16z\" fill=\"\" p-id=\"20605\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol